/**
 * PO Box detection regex.
 * Matches: P.O. Box, PO Box, P O Box, Post Office Box, P.O.B., etc.
 */
const PO_BOX_PATTERN =
  /\b(P\.?\s*O\.?\s*Box|Post\s*Office\s*Box|P\.?\s*O\.?\s*B\.?)\s*\d*\b/i;

/**
 * Returns true if the given address line(s) contain a PO box.
 * @param {...string} addressLines - One or more address lines (address1, address2, etc.)
 * @returns {boolean}
 */
export function isPOBox(...addressLines) {
  const combined = addressLines
    .filter(Boolean)
    .map((s) => String(s).trim())
    .join(' ');
  return PO_BOX_PATTERN.test(combined);
}